// extracted by mini-css-extract-plugin
module.exports = {"Collapse":"style_Collapse__GTU2p","accordion-disabled":"style_accordion-disabled__nkmGP"};